import * as React from 'react';

import CampaignCannedCollectionModuleRenderer from 'bundles/campaigns/module-renderers/CampaignCannedCollectionModuleRenderer';
import { usePageConfigComponentTrackingData } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

const TrackedCampaignCannedCollectionModuleRenderer = () => {
  const pageConfigComponentTrackingData = usePageConfigComponentTrackingData();

  return (
    <CampaignCannedCollectionModuleRenderer
      additionalTrackingData={{ pageConfigComponent: pageConfigComponentTrackingData }}
    />
  );
};

export default TrackedCampaignCannedCollectionModuleRenderer;
